import { Action } from '@ngrx/store';
import { FilterChange } from '../calendar-filter/actions';
import { CalendarFilter, CalendarFiltersState } from '../calendar-filter/state';

export enum ManagerFiltersActionTypes {
  Set = '[Manager Filters] Set',
  Reset = '[Manager Filters] Reset',
  SetAll = '[Manager Filters] Set All',
  LoadDefaultFiltersToUnsaved = '[Manager Filters] Load Default Filters To Unsaved',
  SetAllDefaultFilters = '[Manager Filters] Set All Default Filters',
  SetDefaultUnsavedFilter = '[Manager Filters] Set Default Unsaved Filter',
  SetAllUnsavedAsDefault = '[Manager Filters] Set All Unsaved as Default',
  ClearAllUnsavedFilters = '[Manager Filters] Clear All Unsaved Filters',
  SetAllGridFiltersAsDefault = '[Manager Filters] Set All Grid as Default',
  SetCardsFilter = '[Manager Filters] Set Cards Filter'
}

export class ManagerFiltersReset implements Action {
  public readonly type = ManagerFiltersActionTypes.Reset;
  constructor(public payload?: { name: string; value: CalendarFilter }) {}
}

export class ManagerFiltersSet implements Action {
  public readonly type = ManagerFiltersActionTypes.Set;
  constructor(public payload: FilterChange) {}
}

export class ManagerFiltersSetAll implements Action {
  public readonly type = ManagerFiltersActionTypes.SetAll;
  constructor(public payload: CalendarFiltersState) {}
}

export class ManagerDefaultFiltersApply implements Action {
  public readonly type = ManagerFiltersActionTypes.SetAllUnsavedAsDefault;
}

export class ManagerLoadDefaultFilters implements Action {
  public readonly type = ManagerFiltersActionTypes.LoadDefaultFiltersToUnsaved;
}

export class ManagerDefaultGridFiltersSetAll implements Action {
  public readonly type = ManagerFiltersActionTypes.SetAllGridFiltersAsDefault;

  constructor(public fiterState: CalendarFiltersState = undefined) {}
}

export class ManagerDefaultSetUnsavedFilter implements Action {
  public readonly type = ManagerFiltersActionTypes.SetDefaultUnsavedFilter;
  constructor(public payload: FilterChange) {}
}
export class ManagerSetAllDefaultFilters implements Action {
  public readonly type = ManagerFiltersActionTypes.SetAllDefaultFilters;
  constructor(public payload: CalendarFiltersState) {}
}


export class ManagerClearAllUnsavedFilters implements Action {
  public readonly type = ManagerFiltersActionTypes.ClearAllUnsavedFilters;
}

export class ManagerCardsFiltersSet implements Action {
  public readonly type = ManagerFiltersActionTypes.SetCardsFilter;
  constructor(public payload: FilterChange) {}
}

export type ManagerFiltersActionUnion =
  | ManagerFiltersSet
  | ManagerFiltersReset
  | ManagerFiltersSetAll
  | ManagerDefaultFiltersApply
  | ManagerDefaultSetUnsavedFilter
  | ManagerDefaultGridFiltersSetAll
  | ManagerLoadDefaultFilters
  | ManagerSetAllDefaultFilters
  | ManagerClearAllUnsavedFilters
  | ManagerCardsFiltersSet;
